import { render, staticRenderFns } from "./SupaLink.vue?vue&type=template&id=417122ba&"
import script from "./SupaLink.vue?vue&type=script&lang=js&"
export * from "./SupaLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports